import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';

export const Amendment = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavBar />
      <div className="tax-page">
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">Amendment Returns</h1>
            <Link to="/services" className="tax-notification-body">← Go Back to Services</Link>
          </div>
        </div>

        <div className="tax-content-container">
          <h1 className="tax-section-title">
            Accurate & Hassle-Free Tax Amendments with Litax 
          </h1>
          <p className="tax-section-description">
            At <strong>Litax </strong>, we know that even the most careful taxpayers can make mistakes, 
            miss key deductions, or experience changes that affect their original return. Life happens—whether 
            it’s an overlooked income source, a forgotten credit, or a change in family status. Thankfully, the IRS 
            provides a way to correct these errors through <strong>Amendment Returns (Form 1040X)</strong>.  
          </p>
          <p className="tax-section-description">
            Our team of <strong>Certified Public Accountants (CPAs)</strong> and <strong>Enrolled Agents (EAs)</strong> 
            specializes in guiding clients through this process. We ensure your amendments are filed thoroughly, 
            accurately, and within deadlines, so you remain fully compliant while minimizing stress and maximizing 
            potential benefits.
          </p>

          <h2 className="tax-subheading">When Should You Amend Your Tax Return?</h2>
          <p className="tax-section-description">
            Filing an amendment isn’t required for every mistake. However, you <em>must</em> amend if errors or 
            omissions affect your taxable income, deductions, credits, or filing status. Some common reasons include:
          </p>
          <ul className="tax-section-description">
            <li><strong>Unreported or Underreported Income:</strong> Forgot to include income from freelance projects, 
            rental properties, stock sales, or interest/dividends? Updating your return avoids costly IRS penalties.</li>
            <li><strong>Missed Deductions or Credits:</strong> Realized after filing that you qualify for education 
            credits, business expenses, or home office deductions? An amendment can increase your refund.</li>
            <li><strong>Incorrect Filing Status:</strong> Life events such as marriage, divorce, or a new dependent 
            may require a change from “single” to “married filing jointly” or other statuses.</li>
            <li><strong>Dependent Adjustments:</strong> Adding, removing, or correcting dependent information ensures 
            eligibility for credits like the Child Tax Credit or Earned Income Tax Credit.</li>
            <li><strong>Withholding & Payment Errors:</strong> Mistakes in reporting tax withholdings, estimated 
            payments, or tax credits should be corrected promptly to avoid mismatches.</li>
          </ul>

          <h2 className="tax-subheading">IRS Rules & Limitations on Filing Amendments</h2>
          <p className="tax-section-description">
            While amendments can resolve errors, the IRS has specific rules on when and how they can be filed:
          </p>
          <ul className="tax-section-description">
            <li><strong>Time Limit:</strong> Amendments must generally be filed within <strong>3 years</strong> of the 
            original filing date, or <strong>2 years</strong> from the date you paid the tax—whichever is later.</li>
            <li><strong>No Need for Math Errors:</strong> You don’t need to amend for arithmetic mistakes—the IRS 
            automatically corrects these.</li>
            <li><strong>Form 1040X Requirement:</strong> All amendments are filed using Form 1040X. While more recent 
            years allow e-filing, older years (before 2019) must be filed on paper.</li>
            <li><strong>IRS Scrutiny:</strong> An amendment can trigger a closer review of your return. That’s why 
            accurate, detailed preparation is critical.</li>
          </ul>

          <h2 className="tax-subheading">Our Process: How We Simplify Tax Amendments</h2>
          <p className="tax-section-description">
            Amending a return can feel overwhelming—but at Litax , we make the process clear, simple, 
            and reliable. Our approach includes:
          </p>
          <ul className="tax-section-description">
            <li><strong>Comprehensive Review:</strong> We analyze your original tax filing in detail to identify 
            errors, omissions, or missed opportunities.</li>
            <li><strong>Form 1040X Preparation:</strong> Our experts complete the amendment form with precise 
            explanations and supporting documentation to avoid IRS delays.</li>
            <li><strong>Supporting Schedules:</strong> We update and attach revised schedules or forms whenever 
            necessary, ensuring complete accuracy.</li>
            <li><strong>IRS Representation:</strong> If the IRS raises questions or requires clarification, our team 
            manages communication on your behalf for a smooth resolution.</li>
            <li><strong>Refund & Payment Adjustments:</strong> Whether you’re due a refund or owe additional tax, 
            we ensure payments and claims are handled properly.</li>
          </ul>

          <h2 className="tax-subheading">Why Choose Litax  for Amendments?</h2>
          <p className="tax-section-description">
            <strong>✔ Expertise You Can Trust:</strong> With years of experience, our CPAs and EAs understand the 
            nuances of tax amendments and IRS expectations.  
          </p>
          <p className="tax-section-description">
            <strong>✔ Tailored Solutions:</strong> Every taxpayer’s situation is different. We provide customized 
            strategies that fit your specific needs—whether it’s correcting income, dependents, or credits.  
          </p>
          <p className="tax-section-description">
            <strong>✔ Peace of Mind:</strong> We remove the guesswork and stress by ensuring your amendment is filed 
            correctly, on time, and with supporting documentation.  
          </p>
          <p className="tax-section-description">
            <strong>✔ End-to-End Service:</strong> From reviewing your original return to final IRS confirmation, 
            we guide you through every step of the process.  
          </p>

          <p className="tax-section-description">
            Mistakes don’t have to be costly. With <strong>Litax </strong> by your side, amending your 
            tax return becomes a simple, stress-free process. Don’t let overlooked details or filing errors impact 
            your finances—let us help you correct them quickly and effectively.
          </p>
          <p className="tax-section-description">
            <em>Contact us today to schedule a consultation</em> and learn how we can assist with your 
            <strong>Amendment Returns</strong>. We’re here to provide clarity, confidence, and complete compliance.
          </p>
        </div>
      </div>
      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Amendment;
